import api from "@/services/api.service";

export default {
 name: 'response-contact',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Response Contact list"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    icon: 'fa fa-sort',
    selcol: '',
    items: [],
    items_new: [],
    fields: [
    { key: "#" },
    { key: "actions", stickyColumn: true },
    { key: "uploaded_filename", sortable:false },
    { key: "score", sortable:false },
    { key: "status", sortable:false }],
    sech: {},
    currentPage: 1,
    currentPageNew: 1,
    currentSortDir:'desc',        
    perPage: 10,
    perPageNew: 10,
    totalRows: null,
    totalResponseContact: 0,
    totalResponseContactNew: 0,
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    isApproved : true,
    allSelectedNew: false,
    conflict_cnt:'',
    colName : '',
    permission_list: false,
    superAdmin: false,
    permission_viewConflictResponse: false,
    permission_deleteResponseContacts: false,
    pageOptionsConflict:[{
      text: '10', value: '10',
      }, {
          text: '50', value: '50'
      }, {
          text: '100', value: '100',
      }, {
          text: '250', value: '250',
      }, {
          text: '500', value: '500',
      }],
    pageOptionsNew:[{
          text: '10', value: '10',
      }, {
          text: '50', value: '50'
      }, {
          text: '100', value: '100',
      }, {
          text: '250', value: '250',
      }, {
          text: '500', value: '500',
      }],
  };
},
computed: {},
mounted() {},
async created() {
  let response = await api.post("users/user-permissions");
  const permissions = [];
  if (response.status == "success") {
    response.data[0].permission.forEach( function(element) {                
        permissions.push(element.action)
    }.bind(this));
    if(permissions.includes("uploaded_response_list_event") == true){
      this.getMarketingResponseContacts();
      this.getMarketingResponseContactsNew();
      this.permission_list = permissions.includes("uploaded_response_list_event");
      this.permission_viewConflictResponse = permissions.includes("uploaded_response_details_view_event");
      this.permission_deleteResponseContacts = permissions.includes("uploaded_response_delete_event");
    }else if(response.data[0].role == 'super_admin'){
      this.getMarketingResponseContacts();
      this.getMarketingResponseContactsNew();  
      this.superAdmin = true;
    }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
        this.makeToast("Permission denied","Alert","warning",6000);
        this.$router.push({name: 'List Event'});
    }else{
        this.makeToast("Permission denied","Alert","warning",6000);
        this.$router.push({name: 'Admin Dashboard'});
    }
  }
},
watch: {
  currentPage: {
    handler: function(page) {         
        // this.getMarketingResponseContacts(page);
        this.toSort(this.colName,page); 
    }
  },
  currentPageNew: {
    handler: function(page) {         
        // this.getMarketingResponseContactsNew(page);
        this.toSortNew(this.colName,page); 
    }
  }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  selectAll: function(e) {
    this.delete_ids = [];       
    this.allSelectedNew = false;            
    if(e.target.checked){
      for (var item in this.items) {
        this.delete_ids.push(this.items[item].id.toString());
      }                
    }            
  },
  selectAllNew: function(e) {
    this.delete_ids = []; 
    this.allSelected = false;              
    if(e.target.checked){
      for (var item in this.items_new) {
        this.delete_ids.push(this.items_new[item].id.toString());
      }                
    }            
  },
  selectOne(){
    this.allSelected = false;            
  },
  selectOneNew(){
      this.allSelectedNew = false;            
    },
  async toSort (items,page = 1)
  {
    if (items != "actions" && items != "#" && items != 'uploaded_filename') {                    
    this.items = [];    
    
    if(page == 1)
    if(items == this.colName)
    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 
    
    this.colName = items;
    this.sech.marketing_event_id = this.$route.params.id;
    this.isBusy = true;
    let response = await api.post("marketing-event/get-marketing-response-contacts",{ page:page,columnname:items,sortType:this.currentSortDir,marketing_event_id:this.sech.marketing_event_id,paginateVal:this.perPage });
    if (response.status == "success") {
        if (response.data.records.data != "") {        
          if(this.currentSortDir == 'asc'){
              this.icon1 = 'fa fa-sort-up';                             
              this.selcol = items;        
          } else{ 
              this.icon1 = 'fa fa-sort-down';                             
              this.selcol = items;
          }  
        //Iterate Dat
        response.data.records.data.forEach( function(element) {
          if(element.status == 'Resolved' || element.status == 'Pending'){ 
            
            var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status,marketing_response:element.marketing_responses,conflict_score:element.highScore} )
            this.items.push(someObject);  
          }
        }.bind(this));

        this.conflict_cnt = response.data.conflict_cnt;        
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;
        } else {
        this.items = [];
        this.items_new = [];
      }
    }
    this.isBusy = false;
    }
  },
  async toSortNew (items_new,page = 1)
  {
    if (items_new != "actions" && items_new != "score"  && items_new != "#" && items_new != 'uploaded_filename') {                    
    this.items_new = [];
    
    if(page == 1)
    if(items_new == this.colName)
    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 
    
    this.colName = items_new;
    this.sech.marketing_event_id = this.$route.params.id;
    this.isBusy = true;
    let response = await api.post("marketing-event/get-marketing-response-contacts-new",{ page:page,columnname:items_new,sortType:this.currentSortDir,marketing_event_id:this.sech.marketing_event_id,paginateVal:this.perPageNew });
    if (response.status == "success") {
        if (response.data.records.data != "") {        
          if(this.currentSortDir == 'asc'){
              this.icon1 = 'fa fa-sort-up';                             
              this.selcol = items_new;        
          } else{ 
              this.icon1 = 'fa fa-sort-down';                             
              this.selcol = items_new;
          }  
        //Iterate Data 
        response.data.records.data.forEach( function(element1) {                    
          if(element1.status == 'New'){
            var someObject1 = Object.assign({}, JSON.parse(element1.contact_data), {id:element1.id,status:element1.status,marketing_response:element1.marketing_responses} )
            this.items_new.push(someObject1);  
          }          
        }.bind(this));

        this.totalResponseContactNew = response.data.records.total;        
        this.currentPageNew = response.data.records.current_page;
        this.perPageNew = response.data.records.per_page;
        } else {
        this.items_new = [];
      }
    }
    this.isBusy = false;
  }
  },
  async getMarketingResponseContacts(page) {
    this.items = [];
    this.sech.page = page;
    this.sech.marketing_event_id = this.$route.params.id;
    let response = await api.post("marketing-event/get-marketing-response-contacts", this.sech);

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element) {                    
          if(element.status == 'Resolved' || element.status == 'Pending'){
            var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status,marketing_response:element.marketing_responses,conflict_score:element.highScore} )
            this.items.push(someObject);  
          }          
        }.bind(this));
        this.conflict_cnt = response.data.conflict_cnt;        
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;
        
        // this.pageOptionsConflict = this.pageOptions;
        this.pageOptionsConflict.forEach(element => {
          if(element.value > this.totalResponseContact){
              var indexOf = this.pageOptionsConflict.indexOf(element);
              if( indexOf != 0 )
              this.pageOptionsConflict.splice(indexOf)
          }
        });
        if(this.totalResponseContact <= 500)
        this.pageOptionsConflict.push({text:'All',value:this.totalResponseContact});
      } else {
        this.items = [];
      }
    }else{
      this.makeToast(response.message, 'Alert', 'warning', 6000);
      this.$router.push({name: "List Event"});
    }      
    this.isBusy = false;
  },
  async getMarketingResponseContactsNew(page) {
    this.items_new = [];
    this.sech.page = page;
    this.sech.marketing_event_id = this.$route.params.id;
    let response = await api.post("marketing-event/get-marketing-response-contacts-new", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element1) {                    
          if(element1.status == 'New'){
            var someObject1 = Object.assign({}, JSON.parse(element1.contact_data), {id:element1.id,status:element1.status,marketing_response:element1.marketing_responses} )
            this.isApproved = (element1.resolution == 'new' ? true : false );
            this.items_new.push(someObject1);  
          }          
        }.bind(this));

        this.totalResponseContactNew = response.data.records.total;        
        this.currentPageNew = response.data.records.current_page;
        this.perPageNew = response.data.records.per_page;

        // this.pageOptionsNew = this.pageOptions;
        this.pageOptionsNew.forEach(e => {
          if(e.value > this.totalResponseContactNew){
              var indexOf1 = this.pageOptionsNew.indexOf(e);
              if( indexOf1 != 0 )
              this.pageOptionsNew.splice(indexOf1)
          }
        });
        if(this.totalResponseContactNew <= 500)
        this.pageOptionsNew.push({text:'All',value:this.totalResponseContactNew});
      } else {
        this.items_new = [];
      }
    }      
    this.isBusy = false;
  },
  getRowCount(items) {    
    return items.length;
  },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event response Contacts?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event response Contact?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteMarketingContact(id, index) {

    let response = await api.post("admin/marketing-event/delete-response-contact",
      { id: id , marketing_event_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.getMarketingResponseContacts();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Marketing Event delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Marketing Event not deleted.`, "Alert", "danger");
  },
 async showConflict(id){  
    return this.$router.push({name : "Show Conflict",params: {conflict_id:id}});
  },
  async approveNewResponseContacts(){

    let response = await api.post("admin/marketing-event/approve-newResponse-contacts",
      {marketing_event_id : this.$route.params.id });
    
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {
      this.isApproved = true;
      this.makeToast(response.message || `New Response approved successful.`,"Alert","success");
    } else{
      for (var error in response.errors)
        this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
    } 
  }
}
};
